import { useQuery, useMutation } from '@tanstack/react-query'
import { baseURL, headers } from '@/v2/constants/requests'

const QUERY_KEY = ['SettingsFinance']

export const useSettingsFinance = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: QUERY_KEY,
    queryFn: async () => {
      const res = await fetch(`${baseURL}/v2/rest/settings/finance`, {
        method: 'GET',
        headers,
      })
      if (!res.ok) {
        throw new Error("We couldn't load the finance settings")
      }
      return res.json()
    },
  })

  return { finance: data, isLoading, isError }
}

export const useFinanceOnboarding = () => {
  const { mutateAsync: startOnboarding, ...rest } = useMutation({
    mutationFn: async () => {
      const res = await fetch(
        `${baseURL}/v2/rest/settings/finance/onboarding`,
        {
          method: 'POST',
          headers,
        }
      )
      if (!res.ok) {
        const error = await res.json()
        throw new Error(error.errors || 'Could not start onboarding')
      }
      return res.json()
    },
  })

  return { startOnboarding, ...rest }
}

export const useFinanceDashboard = () => {
  const { mutateAsync: openDashboard, ...rest } = useMutation({
    mutationFn: async () => {
      const res = await fetch(`${baseURL}/v2/rest/settings/finance/dashboard`, {
        method: 'GET',
        headers,
      })
      if (!res.ok) {
        const error = await res.json()
        throw new Error(error.errors || 'Could not open dashboard')
      }
      return res.json()
    },
  })

  return { openDashboard, ...rest }
}
